// Single source of truth for SEO field character limits used by the technical-audit
// edit cards' live character counters (A1). Values preserve prior per-card behaviour.
// Ranges: title 50–60 and meta 150–160 are PDF best-practice; alt text ≤125 is a11y.

export interface CharLimit {
	min: number;
	max: number;
	optimal: { min: number; max: number };
}

export const TITLE_LIMITS: CharLimit = {
	min: 30,
	max: 60,
	optimal: { min: 50, max: 60 },
};

export const META_LIMITS: CharLimit = {
	min: 120,
	max: 160,
	optimal: { min: 150, max: 160 },
};

export const H1_LIMITS: CharLimit = {
	min: 20,
	max: 70,
	optimal: { min: 40, max: 60 },
};

export const ALT_TEXT_LIMITS: CharLimit = {
	min: 5,
	max: 125,
	optimal: { min: 10, max: 125 },
};
